//@ts-nocheck

import {Button} from '_core'
import {ModalBody, ModalHeader} from '_core/components/Modal'
import {PaginationProps} from '_core/components/Modal/ModalBody'
import {KTSVG} from '_metronic/helpers'
import React from 'react'
import {Modal, ModalFooter} from 'react-bootstrap'

type Props = {
  icon?: string
  onClose: () => void
  onConfirm?: () => void
  btnText?: string
  title: string
  subTitle?: string | any
  children?: React.ReactNode
  hideFooter?: any
  size?: any
  disabled?: any
  pagination?: PaginationProps
  footer?: any
  isSubmitting?: boolean
  showModelHeader?: boolean
}

export const OrderModal: React.FC<Props> = ({
  icon,
  onClose,
  btnText,
  title,
  subTitle,
  children,
  hideFooter,
  size,
  onConfirm,
  disabled,
  pagination,
  footer,
  isSubmitting,
  showModelHeader,
}) => {
  return (
    <Modal show={true} onHide={onClose} size={size} centered backdropClassName='opacity-75'>
      {showModelHeader && (
        <ModalHeader
          title={
            <>
              <div className='mt-4'>
                {icon && (
                  <KTSVG
                    className='svg-icon-2x border border-2 border-gray-400 rounded-2 px-2 py-3'
                    path={`/media/icons/corksy/${icon}.svg`}
                  />
                )}
                <div className='mt-6 h3'>{title}</div>
                {subTitle && <div>{subTitle}</div>}
              </div>
            </>
          }
        >
          <KTSVG
            className='svg-icon-2x px-2 py-3 cursor-pointer'
            path='/media/icons/duotune/arrows/arr061.svg'
            onClick={onClose}
          />
        </ModalHeader>
      )}
      <ModalBody pagination={pagination} isOuterPaging>
        {!showModelHeader && (
          <>
            <div className=' d-flex justify-content-between'>
              <span className='mt-4'>
                {icon && (
                  <KTSVG
                    className='svg-icon-2x border border-2 border-gray-400 rounded-2 px-2 py-3'
                    path={`/media/icons/corksy/${icon}.svg`}
                  />
                )}
              </span>
              <KTSVG
                className='svg-icon-2x px-2 py-3 cursor-pointer'
                path='/media/icons/duotune/arrows/arr061.svg'
                onClick={onClose}
              />
            </div>
            <div className='mt-6 h3'>{title}</div>
            {subTitle && <div>{subTitle}</div>}
          </>
        )}
        {children && <div className='pt-2'>{children}</div>}
      </ModalBody>
      <>
        {footer}
        {!hideFooter && (
          <ModalFooter>
            <div className='d-flex col gap-5'>
              <button id='btnClose' className='btn explore-btn-outline w-100' onClick={onClose}>
                Cancel
              </button>
              <Button
                id='btnSave'
                className='btn btn-primary-active w-100'
                onClick={onConfirm}
                title={btnText}
                disabled={disabled}
                isSubmitting={isSubmitting}
              />
            </div>
          </ModalFooter>
        )}
      </>
    </Modal>
  )
}
export default OrderModal
